<template>
    <button class="addquest-button
            addquest-button__white"
            @click="$emit('openInNewWindow')">
        <img src="@/assets/icons/panel/editSession/add-point.svg" style="filter: brightness(0) invert(0);" class="button-image" :alt="$t('com.global.open-in-new-tab')" />
        {{$t('com.global.open-in-new-tab')}}
    </button>
</template>
<script charset="utf-8">
    export default {
        name: "OpenListInNewWindowButton",
        emits: ["openInNewWindow"]
    }
</script>
<style lang="scss" scoped>
    .addquest-button {
        padding: 5px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 0px;
        transition: all 0.2s ease-in-out;

        .button-image {
            height: 20px;
            margin: 0px 5px 0px 0px;
        }

        &__white {
            background: #fff;
            border: 1px solid #bbc2ce;

            &:hover {
                background: #e8ebef;
            }
        }
    }
</style>
